/* eslint-disable complexity */
import React, { memo } from "react";
import PropTypes from "prop-types";
import ClockIcon from "../images/update.svg";
import StarIcon from "../images/star.svg";
import getHighlightedText from "../../../../utils/helpers/get-highlighted-text";
import styles from "../styles.css";
import { NUMBER } from "../../../../constants/app-constants";

const SearchSuggestions = ({
    isHomePage,
    inputSearchValue,
    modifiedSearch,
    popularSearch,
    searchSuggestions,
    noResult,
    onSearchClickHandler
}) => {
    if (isHomePage && !inputSearchValue) {
        return (
            <div styleName={isHomePage ? "styles.homepageSearchDropdownWrapper" : "styles.searchDropdownWrapper"}>
                {(modifiedSearch || []).length > 0 && (
                    <div styleName={"styles.searchHeadingWrapper"}>
                        <p styleName={"styles.searchHeading"}>Recent searches</p>
                    </div>
                )}
                {(modifiedSearch || []).map((item) => (
                    <div
                        styleName={"styles.searchOptionWrap"}
                        key={item.value}
                        onClick={() => onSearchClickHandler({ value: item.value }, "recent", false)}
                    >
                        <div styleName={"styles.searchUpdateWrapper"}>
                            <img src={ClockIcon} />
                            <p styleName={"styles.searchOption"}>{item.value}</p>
                        </div>
                    </div>
                ))}
                {popularSearch.length > 0 && modifiedSearch.length !== NUMBER.SIX && (
                    <React.Fragment>
                        <div styleName={"styles.searchHeadingWrapper"}>
                            <   p styleName={"styles.searchHeading"}>Popular suggestions</p>
                        </div>
                        {popularSearch.slice(0, NUMBER.SIX - modifiedSearch.length).map((item) => (
                            <div
                                styleName={"styles.searchOptionWrap"}
                                key={item}
                                onClick={() => onSearchClickHandler({ value: item }, "popular", false)}
                            >
                                <div styleName={"styles.searchUpdateWrapper"}>
                                    <img src={StarIcon} />
                                    <p styleName={"styles.searchOption"}>{item}</p>
                                </div>
                            </div>
                        ))}</React.Fragment>
                )}
            </div>
        );
    }

    if (inputSearchValue && searchSuggestions.length > 0) {
        return (
            <div styleName={isHomePage ? "styles.homepageSearchDropdownWrapper" : "styles.searchDropdownWrapper"}>
                <div styleName={"styles.searchHeadingWrapper"}>
                    <p styleName={"styles.searchHeading"}>Search Suggestions</p>
                </div>
                {searchSuggestions.map((item, index) => (
                    <div
                        styleName={"styles.searchOptionWrap"}
                        key={item?.label}
                        onClick={() => onSearchClickHandler({ ...item, value: item?.label, label: item?.label }, "modalSearch", false, index)}
                    >
                        <div styleName={"styles.searchUpdateWrapper"}>
                            <p styleName={"styles.searchOption"}>{getHighlightedText(item?.label, inputSearchValue)}</p>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (inputSearchValue && searchSuggestions.length === 0 && noResult) {
        return (
            <div styleName={isHomePage ? "styles.homepageNoSuggestionFound" : "styles.searchHeadingWrapper"}>
                <p styleName={"styles.searchHeading"}>No suggestions found</p>
            </div>
        );
    }

    return null;
};

SearchSuggestions.propTypes = {
    isHomePage: PropTypes.bool,
    inputSearchValue: PropTypes.string,
    modifiedSearch: PropTypes.array,
    popularSearch: PropTypes.array,
    searchSuggestions: PropTypes.array,
    noResult: PropTypes.bool,
    onSearchClickHandler: PropTypes.func
};

export default memo(SearchSuggestions);
